import React, {FC} from 'react';
import styled from 'styled-components';

import {KeyboardShortcutsFilter} from '../../../libs/shared/ui/src/components/keyboard/keyboardShortcutsFilter';
import {topBarHeight} from './topBar/topBarHelpers';

/*
 * Props.
 */

interface AppFrameProps {
  className?: string;
  isVisible: boolean;
}

/*
 * Style.
 */

interface WrapperStyleProps {
  $isVisible: boolean;
}

export const WrapperDiv = styled.div<WrapperStyleProps>`
  position: absolute;
  top: ${topBarHeight}px;
  left: 0px;
  width: 100%;
  height: calc(100% - ${topBarHeight}px);

  visibility: ${(p) => (p.$isVisible ? 'visible' : 'hidden')};

  background: ${(p) => p.theme.greys.white};
`;

/*
 * Component.
 */

export const AppFrame: FC<AppFrameProps> = ({className, isVisible, children}) => (
  <KeyboardShortcutsFilter isEnabled={isVisible}>
    <WrapperDiv className={className} $isVisible={isVisible}>
      {children}
    </WrapperDiv>
  </KeyboardShortcutsFilter>
);
